import { useEffect, useState } from "react";

import ProjectSelector from "./ProjectSelector";
import NewJob from "./NewJob";
import JobStatus from "./JobStatus";
import { Context } from "./Context";

import "../../Css/EditorsTrackerForm.css";
import axios from "axios";

export default function EditorsTrackerForm(props) {
  const [enterprise, setEnterprise] = useState({id: "", name: ""});
  const [project, setProject] = useState({ id: "", name: "", location: "" });
  const [editor, setEditor] = useState("");
  const [currDayJobs, setCurrDayJobs] = useState([]);
  const [editingIssuesTypes, setEditingIssuesTypes] = useState([]);
  const [toShow, setToShow] = useState("project-selector");

  useEffect(() => {
    if (editor) {
      axios({
        method: "get",
        url:
          process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
          "/api/v1/operations/get-ongoing-jobs?editor_id=" +
          editor,
      })
        .then((res) => {
          if (res.status === 200) {
            setCurrDayJobs(res.data.jobs);
            setEditingIssuesTypes(res.data.issues);
          }
        })
        .catch((err) => alert("server error!!!"));
    }
  }, [editor]);

  return (
    <div className="editor-tracker-form">
      <Context.Provider
        value={{
          toShow,
          enterprise,
          project,
          editor,
          currDayJobs,
          editingIssuesTypes,
          setEditor,
          setEnterprise,
          setProject,
          setCurrDayJobs,
          setToShow,
        }}
      >
        <ProjectSelector />
        <NewJob editorIdForJobStatus={editor}/>
        <JobStatus />
      </Context.Provider>
    </div>
  );
}
